/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum PreferredVideoClient {
  Zoom = "Zoom",
}

export const PreferredVideoClientDisplay: Record<PreferredVideoClient, string> = {
  [PreferredVideoClient.Zoom]: "Zoom",
};
